<script lang="ts">
  import { PageSection } from '@athena-lib/Page';
  import PaymentProviderIcons from './PaymentProviderIcons.svelte';
  import LinkCollections from './LinkCollections.svelte';
  import SiteSelector from './SiteSelector.svelte';
  import SocialMediaIcons from './SocialMediaIcons.svelte';
  import type { FooterProps } from './types';

  const {
    linkCollections,
    socialMediaIcons,
    paymentProviderIcons,
    sites,
    newsletterSignupClass,
    onChangeSite,
    action,
  }: FooterProps = $props();
  const year = new Date().getFullYear();
</script>

<PageSection backgroundColor="dark">
  <div class="pb-10 pt-2 md:flex md:pt-10">
    <div class="basis-3/5 md:flex">
      <LinkCollections {linkCollections} {action} />
    </div>
    <div class="basis-2/5">
      <!-- Klaviyo will inject a newsletter signup form into this this div -->
      <div class={newsletterSignupClass}></div>
      <SocialMediaIcons {socialMediaIcons} {action} />
      <div class="block pt-10 md:hidden">
        <SiteSelector {sites} {onChangeSite} />
      </div>
    </div>
  </div>
  <div class="flex items-center">
    <div class="basis-full md:basis-3/5">
      <PaymentProviderIcons {paymentProviderIcons} {action} />
    </div>
    <div class="hidden basis-2/5 md:block">
      <SiteSelector {sites} {onChangeSite} />
    </div>
  </div>
  <div class="mb-4 mt-10 text-center text-sm">&copy; StickerApp {year}</div>
</PageSection>
